import { MultiSelectIsIsNotFilter, SpecialEventValueTypes } from "../SpecialEventsQuery/SpecialEventsQuery.consts";

export const PatientIdentificationOptions = {
  ENGAGED_WITH_PID: "ENGAGED_WITH_PID",
  PID_OUTCOME: "PID_OUTCOME"
};

// Same keys and labels as the Identification tile, so a drawer link opens with the outcome it counted.
export const PidOutcomeValues = [
  { key: "identifiedSuccessfully", label: "Identified successfully" },
  { key: "didntCompleteIdentification", label: "Didn't complete identification" },
  { key: "noRecordOnFile", label: "No record on file" },
  { key: "twoFaNotCompleted", label: "2FA not completed" },
  // eslint-disable-next-line no-secrets/no-secrets
  { key: "multipleMatchingRecords", label: "Multiple matching records" },
  { key: "emergencyDetected", label: "Emergency detected" }
];

export const PatientIdentificationAttributes = {
  [PatientIdentificationOptions.ENGAGED_WITH_PID]: {
    type: "PID_ENGAGED",
    label: "Engaged with PID",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [PatientIdentificationOptions.PID_OUTCOME]: {
    type: "PID_OUTCOME",
    label: "PID outcome",
    valueType: SpecialEventValueTypes.STATIC_DROPDOWN,
    valueOptions: PidOutcomeValues,
    placeholder: "Select outcomes",
    multiSelectOnly: true,
    defaultFilter: MultiSelectIsIsNotFilter.IS.key
  }
};
